export {Edge365Banner} from './Edge365Banner';
